<template>
  <!-- 弹窗 -->
  <modal v-show="openModal" @close="close" class="black-shadow lg-modal" >
    <!-- 弹窗-主体 -->
    <template v-if="openModal" slot="body">
      <slot name="body">
        <div style="display: flex;">
          <div style="position: relative;" :style="boxstyle">
            <div class="close-btn" @click="close">
              <img src="/img/close_w.png"/>
            </div>
            <img :src="image"/>
          </div>
          <div class="resize-box" v-if="false">
            <div class="resize-oprate">
              <div class="resize-btn">
                <md-icon>add</md-icon>
              </div>
            </div>
            <div class="resize-oprate">
              <div class="resize-btn">
                <md-icon>refresh</md-icon>
              </div>
            </div>
            <div class="resize-oprate">
              <div class="resize-btn">
                <md-icon>remove</md-icon>
              </div>
            </div>
          </div>
        </div>
      </slot>
    </template>
  </modal>
</template>
<script>
import { Modal } from '@/components';
export default {
  name: "black-shadow-modal",
  components: { Modal },
  props:{
    boxstyle:{
      type:String,
      default: "",
    },
    image:{
      type: String,
      default: "",
    },
  },
  data(){
    return {
      openModal: false,
    }
  },
  methods:{
    open(){ // 打开弹窗
      this.openModal = true;
      if(this.$listeners["open"]){
        this.$emit('open');
      }
    },
    close(){ // 关闭弹窗
      if(this.openModal){
        this.openModal = false;
        if(this.$listeners["close"]){
          this.$emit('close');
        }
      }
    },
    submit(){
      if(this.$listeners["submit"]){
        this.$emit('submit');
      }
    },
  },
}
</script>
<style scoped>
  .resize-box{
    display:flex;
    flex-direction: column;
    justify-content: center; 
    margin-left: 5px;
  }
  .resize-box .resize-oprate{
    padding: 5px;
    flex: 1;
    align-items: center;
    display: flex;
  }
  .resize-btn{
    align-items: center;
    display: flex;
    height: 100%;
    width: 40px;
    font: 20px;
    font-weight: 600;
    color: #FFFFFF;
    border-radius: 10px;
    background: rgba(0,0,0,.1);
  }

  .black-shadow /deep/ .modal-container{
    box-shadow: none;
    background: none;
    max-width: unset !important;
    padding: 0 90px;
    display: flex;
    justify-content: center;
  }
  .black-shadow{
    background-color: rgba(0,0,0,.3) !important;
  }
  img{
    max-height: 80vh;
    max-width: 100%;
  }
  /deep/ .modal-header, /deep/ .modal-footer, /deep/ .modal-body{
    padding: 0 !important;
  }
  .close-btn{
    background: rgba(0, 0, 0, .4);
    cursor: pointer;
    width: 43px;
    height: 43px;
    position: absolute;
    right: 0;
    top: 0;
  }
</style>